/** React */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "moment/locale/es";

/** MUI icons */
import DeleteIcon from "@mui/icons-material/Delete";

/** MUI */
import {
    Grid,
    MenuItem,
    Typography,
} from "@mui/material";

/** Components */
import BaseSelect2 from "../ui/BaseSelect2";
import conversionFormats from "../Js/conversionFormats";
import conversionsService from "../../services/conversion";
import CustomDatePicker from "../ui/CustomDatePicker";
import FiltersPopover from "../ui/FiltersPopover";

const defaultFilter = {
    filtersArray: [
        {
            type: "",
            value: "",
            since: "",
            until: "",
        },
    ],
};

const FiltersButton = (props) => {
    const { accounts, users, company, setConversions, setShowSkeleton, franchise, grupal, todos } = props;

    const [t, i18n] = useTranslation("global");

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [filters, setFilters] = React.useState(defaultFilter);
    const [language, setLanguage] = useState(sessionStorage.getItem("lng"));

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    /* Filtraríamos por Banco (cuenta bancaria), fecha de carga (campo desde y hasta), formato, fecha de estados de cuenta (fecha desde y hasta), usuario y estatus.*/

    const attributes = [
        { id: 1, name: t("dashboard.bank"), query: "account_id_filter" },
        { id: 2, name: t("converter.uploadDate"), query: "uploaded" },
        { id: 3, name: t("converter.format"), query: "format" },
        { id: 4, name: t("converter.bankStatementDate"), query: "period" },
        { id: 5, name: t("converter.user"), query: "user_name" },
        { id: 6, name: t("converter.status"), query: "id_status" },
    ];

    const status = [
        { id: 1, name: t("converter.inProc") },
        { id: 2, name: t("converter.convertible") },
        { id: 3, name: t("converter.successful") },
        { id: 4, name: t("converter.inReview") },
        { id: 5, name: t("converter.invalid") },
    ];

    const addFilter = () => {
        let array = [...filters.filtersArray];

        if (array.length <= 6) {
            setFilters({
                ...filters,
                filtersArray: [
                    ...filters.filtersArray,
                    {
                        type: "",
                        value: "",
                        since: "",
                        until: "",
                    },
                ],
            });
        }
    };

    const removeFilter = async (index) => {
        let array = [...filters.filtersArray];

        if (index !== -1) {
            array.splice(index, 1);
            setFilters({
                ...filters,
                filtersArray: array,
            });

            setShowSkeleton(true);

            let objectFinal = {};

            array.forEach((item) => {
                if (item.value && item.type) {
                    return (objectFinal[attributes.find((item2) => item2.id === item.type).query] = item.value);
                }
                if (item.type && item.since) {
                    return (objectFinal[attributes.find((item2) => item2.id === item.type).query + "_since"] =
                        item.since.format("YYYY-MM-DD"));
                }
                if (item.type && item.until) {
                    return (objectFinal[attributes.find((item2) => item2.id === item.type).query + "_until"] =
                        item.until.format("YYYY-MM-DD"));
                }
            });

            await conversionsService
                .getConversionsByFranchise({ franchise_id: franchise ?? undefined, grouped: todos.isGrouped ?? false, ...objectFinal })
                .then((response) => {
                    if (response.length > 0) {
                        setConversions(response);
                    } else {
                        setConversions([]);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

            setShowSkeleton(false);
        }
    };

    const removeFirstFilter = async () => {
        setShowSkeleton(true);
        setFilters({
            filtersArray: [
                {
                    type: "",
                    value: "",
                    since: "",
                    until: "",
                },
            ],
        });

        await conversionsService
            .getConversionsByFranchise({ franchise_id: franchise ?? undefined, grouped: todos.isGrouped ?? false })
            .then((response) => {
                if (response.length > 0) {
                    setConversions(response);
                } else {
                    setConversions([]);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        setShowSkeleton(false);
    };

    const handleChangeType = (event, index) => {
        let aux = [...filters.filtersArray];
        aux[index].type = event.target.value;
        aux[index].value = "";
        aux[index].since = "";
        aux[index].until = "";

        setFilters({
            ...filters,
            filtersArray: aux,
        });
    };

    const handleChangeFilter = async (event, index, filterType) => {
        let aux = [...filters.filtersArray];

        aux[index].value = event.target.value;
        aux[index].since = "";
        aux[index].until = "";

        setShowSkeleton(true);

        let objectFinal = {};

        aux.forEach((item) => {
            if (item.value && item.type) {
                objectFinal[attributes.find((item2) => item2.id === item.type).query] = item.value;
            }
            if (item.type && item.since) {
                objectFinal[attributes.find((item2) => item2.id === item.type).query + "_since"] = item.since.format("YYYY-MM-DD");
            }
            if (item.type && item.until) {
                objectFinal[attributes.find((item2) => item2.id === item.type).query + "_until"] = item.until.format("YYYY-MM-DD");
            }
        });

        await conversionsService
            .getConversionsByFranchise({ franchise_id: franchise ?? undefined, grouped: todos.isGrouped ?? false, ...objectFinal })
            .then((response) => {
                if (response.length > 0) {
                    setConversions(response);
                } else {
                    setConversions([]);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        setFilters({
            ...filters,
            filtersArray: aux,
        });

        setShowSkeleton(false);
    };

    const handleChangeFilterRange = async (event, index, filterType, range) => {
        let aux = [...filters.filtersArray];
        aux[index][range] = event;
        aux[index].value = "";

        setShowSkeleton(true);

        let objectFinal = {};

        aux.forEach((item) => {
            if (item.value && item.type) {
                objectFinal[attributes.find((item2) => item2.id === item.type).query] = item.value;
            }
            if (item.type && item.since) {
                objectFinal[attributes.find((item2) => item2.id === item.type).query + "_since"] = item.since.format("YYYY-MM-DD");
            }
            if (item.type && item.until) {
                objectFinal[attributes.find((item2) => item2.id === item.type).query + "_until"] = item.until.format("YYYY-MM-DD");
            }
        });

        await conversionsService
            .getConversionsByFranchise({ franchise_id: franchise ?? undefined, grouped: todos.isGrouped ?? false, ...objectFinal })
            .then((response) => {
                if (response.length > 0) {
                    setConversions(response);
                } else {
                    setConversions([]);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        setFilters({
            ...filters,
            filtersArray: aux,
        });

        setShowSkeleton(false);
    };

    const cleanFilters = async (e) => {
        if (e.target.classList.contains("MuiAvatar-img")) {
            setShowSkeleton(true);
            setFilters({
                filtersArray: [
                    {
                        type: "",
                        value: "",
                        since: "",
                        until: "",
                    },
                ],
            });

            await conversionsService
                .getConversionsByFranchise({ franchise_id: franchise ?? undefined, grouped: todos.isGrouped ?? false })
                .then((response) => {
                    if (response.length > 0) {
                        setConversions(response);
                    } else {
                        setConversions([]);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

            setShowSkeleton(false);
        }
    };

    useEffect(() => {
        setFilters({
            filtersArray: [
                {
                    type: "",
                    value: "",
                    since: "",
                    until: "",
                },
            ],
        });
    }, [company, franchise, grupal]);

    useEffect(() => {
        if (i18n.language) {
            setLanguage(i18n.language);
        }
    }, [i18n.language]);

    return (
        <FiltersPopover
            id={id}
            open={open}
            anchorEl={anchorEl}
            handleClose={handleClose}
            cleanFilters={cleanFilters}
            handleClick={handleClick}
            length={filters.filtersArray.filter((item) => item.type && (item.value || item.since || item.until)).length}
            addFilter={addFilter}
            disabled={filters.filtersArray.length === 6}
        >
            {filters.filtersArray.map((value, index) => (
                <Grid container spacing={2} alignItems="center" key={"histComponent_" + index} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={11}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <BaseSelect2
                                    size="small"
                                    value={value.type}
                                    onChange={(e) => handleChangeType(e, index)}
                                    label={t("filters.attribute")}
                                >
                                    {value.type !== "" ?
                                        attributes.filter(
                                        (item) => !filters.filtersArray
                                            .map((item) => item.type)
                                            .includes(item.id)
                                        )
                                        .concat(attributes.filter((item) => item.id === value.type))
                                        .map((item) => (
                                            <MenuItem value={item.id} key={"attr_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))
                                    : attributes.filter(
                                        (item) => !filters.filtersArray
                                            .map((item) => item.type)
                                            .includes(item.id)
                                    )
                                    .map((item) => (
                                        <MenuItem value={item.id} key={"attr_" + item.id}>
                                            <Typography
                                                variant="body1"
                                                component="span"
                                                align="center"
                                                color="textPrimary"
                                                sx={{
                                                    fontStyle: "normal",
                                                }}
                                            >
                                                {item.name}
                                            </Typography>
                                        </MenuItem>
                                    ))}
                                </BaseSelect2>
                            </Grid>
                            {value.type === "" && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        size="small"
                                        value={value.type}
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeType(e, index)}
                                        values={[]}
                                        disabled
                                    />
                                </Grid>
                            )}
                            {value.type === 1 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {accounts.map((item) => (
                                            <MenuItem value={item.id} key={"accounts_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{ fontStyle: "normal" }}
                                                >
                                                    {`${item.name} | ${item.bankName}`}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {(value.type === 2 || value.type === 4) && (
                                <>
                                    <Grid item xs={6} md={3}>
                                        <CustomDatePicker
                                            label={t("filters.since")}
                                            onChange={(e) => handleChangeFilterRange(e, index, value.type, "since")}
                                            value={value.since ? value.since : null}
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <CustomDatePicker
                                            label={t("filters.until")}
                                            value={value.until !== "" ? value.until : null}
                                            onChange={(e) => handleChangeFilterRange(e, index, value.type, "until")}
                                            minDate={
                                                filters.filtersArray[index]?.since !== "" ? filters.filtersArray[index].since : null
                                            }
                                        />
                                    </Grid>
                                </>
                            )}
                            {value.type === 3 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {conversionFormats.map((item) => (
                                            <MenuItem value={item.id} key={"formats_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {language === "es" ? item.name : item.name_en}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 5 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {users.map((item) => (
                                            <MenuItem value={item} key={"users_" + item}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                            {value.type === 6 && (
                                <Grid item xs={12} md={6}>
                                    <BaseSelect2
                                        label={t("filters.select")}
                                        onChange={(e) => handleChangeFilter(e, index, value.type)}
                                        size="small"
                                        value={value.value}
                                    >
                                        {status.map((item) => (
                                            <MenuItem value={item.id} key={"status_" + item.id}>
                                                <Typography
                                                    variant="body1"
                                                    component="span"
                                                    align="center"
                                                    color="textPrimary"
                                                    sx={{
                                                        fontStyle: "normal",
                                                    }}
                                                >
                                                    {item.name}
                                                </Typography>
                                            </MenuItem>
                                        ))}
                                    </BaseSelect2>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={1} display="flex" justifyContent="center">
                        {filters.filtersArray.length > 1 && (
                            <DeleteIcon
                                color="primary"
                                sx={{ cursor: "pointer" }}
                                onClick={() => removeFilter(index)}
                            />
                        )}
                        {filters.filtersArray.length === 1 &&
                            (value.value !== "" || value.since !== "" || value.until !== "") && (
                                <DeleteIcon
                                    color="primary"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => removeFirstFilter()}
                                />
                            )}
                    </Grid>
                </Grid>
            ))}
        </FiltersPopover>
    );
};

export default FiltersButton;
